module.exports = __webpack_public_path__ + "img/chevron-black-up.bc020b2f.svg";